module.exports = __webpack_public_path__ + "assets/img/enterprise-domain-why-icon-3.0c003164.png";